<template>
  <v-container>

    <page-title title="Checkout">
    </page-title>

    <v-row v-if="isQuotaValid">
      <v-col cols="12"
             sm="6">
        <v-card class="mb-4">
          <v-card-title>
            Plan
          </v-card-title>
          <v-card-text>
            <p v-if="pricingPlan">
              You are on the {{ pricingPlan.name }} plan, billed {{ team.is_billing_yearly ? 'annually' : 'monthly' }}.
            </p>
            <div class="d-flex justify-space-between">
              <div class="d-flex">
                <div class="mr-2">
                  {{ newSeatsQuota | pluralize('seat') }}
                </div>
                <div v-if="team.is_billing_yearly">
                  x {{ (team.license_price / 100) * 12 | money }}
                </div>
                <div v-else>
                  x {{ (team.license_price / 100) | money }}
                </div>
              </div>
              <div class="text-right">
                <div>
                  {{ totalPrice | money }}
                </div>
                <small>
                  {{ team.is_billing_yearly ? 'Annually' : 'Monthly' }}
                </small>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-title>
            Payment Method
          </v-card-title>
          <v-card-text v-if="team.is_billing_yearly">
            We will send you an invoice shortly.
          </v-card-text>
          <v-card-text v-else>
            Your credit card will be charged shortly.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12"
             sm="6">
        <v-form @submit.prevent="submit"
                :disabled="busy || !isQuotaValid">
          <v-card>
            <v-card-title>
              Summary
            </v-card-title>
            <v-card-text>
              <div class="d-flex justify-space-between mb-3">
                <div>
                  Subtotal
                </div>
                <div>
                  {{ totalPrice | money }}
                </div>
              </div>

              <div class="d-flex justify-space-between mb-3">
                <div>
                  <strong>
                    Total {{ team.is_billing_yearly ? 'annual' : 'monthly' }} recurring payment
                  </strong>
                  <div>
                    Next billing date {{ team.license_end_date | datetime('MMMM D, YYYY') }}
                  </div>
                </div>
                <div>
                  <strong>
                    {{ totalPrice | money }}
                  </strong>
                </div>
              </div>
              <div class="d-flex justify-space-between py-3">
                <div>
                  <strong>
                    Amount charged today
                  </strong>
                  <div>
                    {{ addedSeats | pluralize('seat') }} x {{ (team.license_price / 100) | money('$', 2) }} x {{ monthsUntilLicenseEndDate | pluralize('month') }}
                  </div>
                  <!--<div>
                    For {{ addedSeats }} new {{ addedSeats | pluralize('seat', false) }}. You will have {{ newSeatsQuota | pluralize('seats') }}.
                  </div>-->
                </div>
                <div>
                  <strong>
                    {{ proratedAmount | money }}
                  </strong>
                </div>
              </div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn :to="{name: 'subscription'}"
                     outlined>
                &larr;
                Back
              </v-btn>
              <v-btn type="submit"
                     color="primary"
                     :disabled="busy || !isQuotaValid">
                Confirm Purchase
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-alert type="warning"
             v-else>
      {{ newSeatsQuota }} is an invalid seat count.
      <router-link :to="{name: 'subscription'}" class="white--text">Go back.</router-link>
    </v-alert>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import moment from 'moment-timezone';
import subscriptionService from '../../../../ml/services/subscriptionService';
import PageTitle from '../../components/PageTitle';
import pricingPlanService from '../../../../ml/services/pricingPlanService';

export default {
  components: {PageTitle},
  data() {
    return {
      busy: false,
      form: new Form({}),
      pricingPlan: null,
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'team',
      'user',
      'users',
    ]),
    newSeats() {
      return this.newSeatsQuota - this.team.max_users;
    },
    isQuotaValid() {
      return this.newSeatsQuota > this.team.max_users;
    },
    addedSeats() {
      return this.newSeatsQuota - this.team.max_users;
    },
    newSeatsQuota() {
      return parseInt(this.$route.query.new_seats_quota);
    },
    monthsUntilLicenseEndDate() {
      const end = moment(this.team.license_end_date).endOf('month');
      const start = moment().subtract(1, 'month').endOf('month');
      console.log(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'), end.diff(start, 'months'));
      return end.diff(start, 'months');
    },
    proratedAmount() {
      return this.newSeats * (this.team.license_price / 100) * this.monthsUntilLicenseEndDate;
    },
    totalPrice() {
      if (this.team.is_billing_yearly) {
        return this.newSeatsQuota * (this.team.license_price / 100) * 12;
      }
      return this.newSeatsQuota * (this.team.license_price / 100);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      pricingPlanService.getPlan(this.team.pricing_plan_id)
        .then(data => {
          this.pricingPlan = data;
        })
    },
    async submit() {
      if (this.busy) {
        return;
      }
      if (!this.isQuotaValid) {
        return;
      }
      this.busy = true;

      try {
        if (this.team.billing_invoice) {
          const form = {
            billing_interval: 'year',
            users: this.newSeatsQuota,
          }
          await subscriptionService.subscribeWithInvoice(this.team.id, form);

        } else {
          const form = {
            billing_interval: 'month',
            users: this.newSeatsQuota,
          }
          await subscriptionService.subscribeWithCreditCard(this.team.id, form);
        }

        this.$toast.success(`Subscription updated.`);

        this.$router.push({name: 'subscription'});
      } catch (err) {

      } finally {
        this.busy = false;
        await this.$store.dispatch('fetchUser');
      }
    }
  }
}
</script>
